import type { ChatContactUser } from '@/components/Messenger/sidebar/ChatSidebar';

export function getUserDisplayName(u: ChatContactUser): string {
  if (u.name?.trim()) return u.name.trim();
  const fn = u.first_name ?? '';
  const ln = u.last_name ?? '';
  return `${fn} ${ln}`.trim() || u.id;
}
